import Typesense from 'typesense';

const TYPESENSE_HOST = process.env.NEXT_PUBLIC_TYPESENSE_HOST as string;
const TYPESENSE_PORT = process.env.NEXT_PUBLIC_TYPESENSE_PORT as string;
const TYPESENSE_PROTOCOL = process.env.NEXT_PUBLIC_TYPESENSE_PROTOCOL as string;
const TYPESENSE_API_KEY = process.env
  .NEXT_PUBLIC_TYPESENSE_SEARCH_ONLY_API_KEY as string;

export const client = new Typesense.Client({
  nodes: [
    {
      host: TYPESENSE_HOST,
      port: Number(TYPESENSE_PORT),
      protocol: TYPESENSE_PROTOCOL,
    },
  ],
  apiKey: TYPESENSE_API_KEY,
  connectionTimeoutSeconds: 2,
});
